import React from "react";
import { useTranslation } from "react-i18next";

import { useAppContext } from "@/contexts";
import { type PhqOption, usePhq } from "@/hooks";
import { shouldAskBaselineOutcomes } from "@/utils/survey/outcomes";

import { QuestionComponentProps, QuestionDefinition } from "../../../Question";
import { MultipleChoiceQuestion } from "../../core";

const QUESTION_ID = "phq1";

declare module "@/contexts" {
  interface SurveyAnswers {
    phq1?: PhqOption;
  }
}

const Phq1Question: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { enrollmentType, surveyMetadata } = useAppContext();
  const { phqOptions } = usePhq();
  const { t } = useTranslation();

  const questionDescription =
    enrollmentType === "INITIAL_ENROLLMENT"
      ? t("phq1.questionDescription.enrollment")
      : "";
  const questionText =
    surveyMetadata?.name === "RECURRING_OUTCOMES"
      ? t("phq1.questionText.recurringOutcomes")
      : t("phq1.questionText.enrollment");

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={phqOptions}
      questionId={QUESTION_ID}
      questionDescription={questionDescription}
      questionText={questionText}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_PHQ_1: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: [
    "WEIGHT",
    "MOOD",
    "DPP",
    "DIABETES_LIFESTYLE",
    "MED",
    "NMPBA",
  ],
  shouldShowQuestion: ({ partnerInfo }) =>
    shouldAskBaselineOutcomes(partnerInfo),
  component: Phq1Question,
};

export const Q_RETRIAGE_PHQ_1: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["MED", "NMPBA"],
  shouldShowQuestion: () => true,
  component: Phq1Question,
};
